<template>
  <span v-tooltip:top="tooltip" class="tw-truncate">
    <template v-if="moment(date).isValid()">
      <span>{{ moment(date).format(format) }}</span>
    </template>
    <span v-else>{{ defaultContent }}</span>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    date: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'Y-MM-DD',
    },
    tooltip: {
      type: String,
      default: '',
    },
    defaultContent: {
      type: String,
      default: '-',
    },
  },
  computed: {
    moment: () => moment,
  },
}
</script>

<style scoped></style>
